import { loginTour } from "./tours/loginTour";
import { registerTour } from "./tours/registerTour";
import { dashboardHubTour } from "./tours/dashboardHubTour";
import { dashboardBoardsTour } from "./tours/dashboardBoardsTour";
import { dashboardPersonalTaskTour } from "./tours/dashboardPersonalTaskTour";
import { boardCoreTour } from "./tours/boardCoreTour";
import { boardTopMenuTour } from "./tours/boardTopMenuTour";
import { boardSideMenuTour } from "./tours/boardSideMenuTour";
import { boardViewSwitcherTour } from "./tours/boardViewSwitcherTour";
import { boardTodoTour } from "./tours/boardTodoTour";
import { boardTaskDetailTour } from "./tours/boardTaskDetailTour";
import { boardCalenderTour } from "./tours/boardCalenderTour";
import { boardGanttTour } from "./tours/boardGanttTour";
import { boardRoadmapTour } from "./tours/boardRoadmapTour";
import { boardSprintTour } from "./tours/boardSprintTour";
import { boardBacklogTour } from "./tours/boardBacklogTour";
import { boardSummaryTour } from "./tours/boardSummaryTour";
import { boardReportTour } from "./tours/boardReportTour";
import { boardKpiTour } from "./tours/boardKpiTour";
import { boardWBSTour } from "./tours/boardWBSTour";
import { boardFlowChartTour } from "./tours/boardFlowChartTour";
import { boardFlowChartListTour } from "./tours/boardFlowChartListTour";
import { boardSettingTour } from "./tours/boardSettingTour";
import { boardPackageTour } from "./tours/boardPackageTour";
import { boardCopilotSettingsTour } from "./tours/boardCopilotSettingsTour";
import { boardAutomationTour } from "./tours/boardAutomationTour";
import { boardAccountabilityTour } from "./tours/boardAccountabilityTour";
import { boardMedalSettingsTour } from "./tours/boardMedalSettingsTour";
import { boardMembersTour } from "./tours/boardMembersTour";
import { boardCharterTour } from "./tours/boardCharterTour";
import { boardDailyReportTour } from "./tours/boardDailyReportTour";
import { boardFinancialTour } from "./tours/boardFinancialTour";
import { boardDocumentationTour } from "./tours/boardDocumentationTour";
import { boardResourcesTour } from "./tours/boardResourcesTour";
import { boardReminderTour } from "./tours/boardReminderTour";
import { boardChannelTour } from "./tours/boardChannelTour";
import { boardFormTour } from "./tours/boardFormTour";
import { boardWhiteSpaceTour } from "./tours/boardWhiteSpaceTour";
import { boardMeetingMinutesTour } from "./tours/boardMeetingMinutesTour";
import { boardCorrespondenceTour } from "./tours/boardCorrespondenceTour";
import { boardCRMTour } from "./tours/boardCRMTour";
import { boardAiStudioTour } from "./tours/boardAiStudioTour";
import { boardCoachTour } from "./tours/boardCoachTour";
import { feedTour } from "./tours/feedTour";
import { boardAdvocacyReviewTour } from "./tours/boardAdvocacyReviewTour";
import { boardArchivedTasksTour } from "./tours/boardArchivedTasksTour";
import { boardScreenCheckTour } from "./tours/boardScreenCheckTour";
import { boardBoardCallTour } from "./tours/boardBoardCallTour";
import { boardChatTour } from "./tours/boardChatTour";
import { boardHistoryTour } from "./tours/boardHistoryTour";
import { boardImportExportTour } from "./tours/boardImportExportTour";
import { boardMeetingTour } from "./tours/boardMeetingTour";
import { boardWorkloadTour } from "./tours/boardWorkloadTour";
import { boardAddTaskTour } from "./tours/boardAddTaskTour";
import { boardCopilotTour } from "./tours/boardCopilotTour";
import { userProfileSettingsTour } from "./tours/userProfileSettingsTour";
import { profileTour } from "./tours/profileTour";
import { boardMyTasksTour } from "./tours/boardMyTasksTour";
import { searchUsersTour } from "./tours/searchUsersTour";
import { programDetailTour } from "./tours/programDetailTour";
import { dashboardDailyReportTour } from "./tours/dashboardDailyReportTour";
import { screenRecorderTour } from "./tours/screenRecorderTour";
import { affiliateTour } from "./tours/affiliateTour";
import { boardAddFormTour } from "./tours/boardAddFormTour";
import { boardFormCategoriesTour } from "./tours/boardFormCategoriesTour";
import { boardCompletedFormsTour } from "./tours/boardCompletedFormsTour";
import { boardFinancialPaymentsTour } from "./tours/boardFinancialPaymentsTour";
import { chatsTour } from "./tours/chatsTour";

export const allTours = {
  login: loginTour,
  register: registerTour,
  dashboardHub: dashboardHubTour,
  dashboardBoards: dashboardBoardsTour,
  dashboardPersonalTask: dashboardPersonalTaskTour,
  boardCore: boardCoreTour,
  boardTopMenu: boardTopMenuTour,
  boardSideMenu: boardSideMenuTour,
  boardViewSwitcher: boardViewSwitcherTour,
  boardTodo: boardTodoTour,
  boardTaskDetail: boardTaskDetailTour,
  boardCalender: boardCalenderTour,
  boardGantt: boardGanttTour,
  boardRoadmap: boardRoadmapTour,
  boardSprint: boardSprintTour,
  boardBacklog: boardBacklogTour,
  boardSummary: boardSummaryTour,
  boardReport: boardReportTour,
  boardKpi: boardKpiTour,
  boardWBS: boardWBSTour,
  boardFlowChart: boardFlowChartTour,
  boardFlowChartList: boardFlowChartListTour,
  boardSetting: boardSettingTour,
  boardPackage: boardPackageTour,
  boardCopilotSettings: boardCopilotSettingsTour,
  boardAutomation: boardAutomationTour,
  boardAccountability: boardAccountabilityTour,
  boardMedalSettings: boardMedalSettingsTour,
  boardMembers: boardMembersTour,
  boardCharter: boardCharterTour,
  boardDailyReport: boardDailyReportTour,
  boardFinancial: boardFinancialTour,
  boardDocumentation: boardDocumentationTour,
  boardResources: boardResourcesTour,
  boardReminder: boardReminderTour,
  boardChannel: boardChannelTour,
  boardForm: boardFormTour,
  boardWhiteSpace: boardWhiteSpaceTour,
  boardMeetingMinutes: boardMeetingMinutesTour,
  boardCorrespondence: boardCorrespondenceTour,
  boardCRM: boardCRMTour,
  boardAiStudio: boardAiStudioTour,
  boardCoach: boardCoachTour,
  boardAdvocacyReview: boardAdvocacyReviewTour,
  boardArchivedTasks: boardArchivedTasksTour,
  boardScreenCheck: boardScreenCheckTour,
  boardBoardCall: boardBoardCallTour,
  boardChat: boardChatTour,
  boardHistory: boardHistoryTour,
  boardImportExport: boardImportExportTour,
  boardMeeting: boardMeetingTour,
  boardWorkload: boardWorkloadTour,
  boardAddTask: boardAddTaskTour,
  boardCopilot: boardCopilotTour,
  feed: feedTour,
  userProfileSettings: userProfileSettingsTour,
  profile: profileTour,
  boardMyTasks: boardMyTasksTour,
  searchUsers: searchUsersTour,
  programDetail: programDetailTour,
  dashboardDailyReport: dashboardDailyReportTour,
  screenRecorder: screenRecorderTour,
  affiliate: affiliateTour,
  boardAddForm: boardAddFormTour,
  boardFormCategories: boardFormCategoriesTour,
  boardCompletedForms: boardCompletedFormsTour,
  boardFinancialPayments: boardFinancialPaymentsTour,
  chats: chatsTour,
};

export function getTour(key) {
  return allTours[key] || null;
}
